import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface FormModalProps {
  onConfirm: () => void
  onCancel: () => void
  children?: ReactNode
}

const FormModal: React.FC<FormModalProps> = ({ onConfirm, onCancel, children }) => {
  return (
    <Overlay>
      <Modal>
        <ModalHeader>
          <CloseBtn onClick={onCancel}>✕</CloseBtn>
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
      </Modal>
    </Overlay>
  )
}

export default FormModal

// ─── Styles ──────────────────────────────────────────────────────────────────

const Overlay = styled.div`
  position: fixed;
  z-index: 400;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
`

const Modal = styled.div`
  background: #161616;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  width: min(600px, 90vw);
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px 0;
`

const ModalBody = styled.div`
  padding: 8px 24px 24px;
`

const CloseBtn = styled.button`
  background: none;
  border: none;
  color: #777;
  font-size: 14px;
  cursor: pointer;
  line-height: 1;
  padding: 4px;
  transition: color 0.15s;
  &:hover { color: #a0a0a0; }
`
